class ScImageComparison extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-comparison-input]');

    if (!this.input) return;

    this.update = this.update.bind(this);
    this.input.addEventListener('input', this.update);
    this.update();
  }

  disconnectedCallback() {
    this.input?.removeEventListener('input', this.update);
  }

  update() {
    const position = Number(this.input.value);
    this.style.setProperty('--comparison-position', `${position}%`);
    this.input.setAttribute('aria-valuetext', `${position}% before image`);
  }
}

if (!customElements.get('sc-image-comparison')) {
  customElements.define('sc-image-comparison', ScImageComparison);
}
